import { AppointmentBookComponent } from 'src/app/front-office/appointment-book/appointment-book.component';
import { AppointmentBookService } from 'src/app/services/appointment-book.service';
import { Appointment, AppointmentState } from './appointment-book.models';
import { ClientInfo } from './clientInfo.model';


export class BookAptInfo {
  showClientFinder: boolean = true;
  showClientInfo: boolean = true; // false;
  showDateTimePanel: boolean = true; // false;
  showSessionResourcePanel: boolean = true; // false;
  showMakeSalePanel: boolean = false;
  showBookApt: boolean = false;
  apt: Appointment = null;
  appointmentId: number = -1;
  DisclaimerCode: string = "";
  SafetyPolicyDisclaimerRequired: boolean = false;
  SkinTypeDisclaimerRequired: boolean = false;

  private requestedStartTimeInternal: Date = null;
  get requestedStartTime(): Date {
    return this.requestedStartTimeInternal;
  }
  set requestedStartTime(value: Date) {
    this.requestedStartTimeInternal = value;
  }

  waitTime: number = 0;
  startTime: Date = null;
  endTime: Date = null;
  clientInfo: ClientInfo = null;
  clientId: number = -1;
  sessionId: number = -1;
  resourceId: number = -1;
  branchId: number = -1;
  employee: number = -1;
  State: AppointmentState = AppointmentState.New;
  PreSessionDelay: number = 0;
  PostSessionDelay: number = 0;
  Terminal: number = -1;
  Locked: boolean = false;
  PaymentAfterSession: boolean = false;

  Reset() {
    this.waitTime = 0;
    this.showClientFinder = true;
    this.showClientInfo = false;
    this.showDateTimePanel = false;
    this.showSessionResourcePanel = false;
    this.showMakeSalePanel = false;
    this.showBookApt = false;
    this.apt = null;
    this.startTime = new Date();
    this.endTime = new Date();
    this.requestedStartTime = new Date(this.startTime);
    this.clientInfo = null;
    this.clientId = -1;
    this.sessionId = -1;
    this.resourceId = -1;
    this.branchId = -1;
    this.appointmentId = -1;
    this.employee = -1;
    this.State = AppointmentState.New;
    this.PreSessionDelay = 0;
    this.PostSessionDelay = 0;
    this.DisclaimerCode = "";
    this.SafetyPolicyDisclaimerRequired = false;
    this.SkinTypeDisclaimerRequired = false;
    this.Terminal = -1;
    this.Locked = false;
    this.PaymentAfterSession = false;
  }
}
